import { Box } from '@mui/material';
import { SCRIVE_TYPE } from '@treyd-io/core/constants/auth';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { OtpBody } from './OtpBody';
import { PhoneBody } from './PhoneBody';

type Step = 'phoneDigits' | 'otp';

interface Props {
  switchSigningMethod: () => void;
  onPhoneDigitsSubmit: (phone: string) => Promise<void>;
  onOtpSubmit: (otp: string, phone: string) => void;
  onClickBack: () => Promise<void>;
  cancelSignCallback: () => void;
  showActions?: boolean;
  country: string;
  isLoading: boolean;
  type: SCRIVE_TYPE;
}

export const OtpDialog = (props: Props) => {
  const {
    switchSigningMethod,
    onPhoneDigitsSubmit,
    onOtpSubmit: handleOtpSubmit,
    cancelSignCallback,
    onClickBack,
    showActions,
    country,
    isLoading,
    type,
  } = props;
  const [activeStep, setActiveStep] = useState<Step>('phoneDigits');
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  useEffectOnce(() => {
    cancelSignCallback();
  });

  const handlePhoneDigitsSubmit = async (phone: string) => {
    onPhoneDigitsSubmit(phone).finally(() => {
      setPhoneNumber(phone);
      setActiveStep('otp');
    });
  };

  const handleBackClick = async () => {
    onClickBack().then(() => {
      setActiveStep('phoneDigits');
    });
  };

  const STEPS: Record<Step, React.ReactNode> = {
    phoneDigits: (
      <PhoneBody
        type={type}
        onSubmit={handlePhoneDigitsSubmit}
        onSignWithBankClick={switchSigningMethod}
        showActions={showActions}
        country={country}
        loading={isLoading}
      />
    ),
    otp: (
      <OtpBody
        type={type}
        onSubmit={(otp) => handleOtpSubmit(otp, phoneNumber)}
        onResend={() => onPhoneDigitsSubmit(phoneNumber)}
        onBackClick={handleBackClick}
        loading={isLoading}
      />
    ),
  };

  return <Box>{STEPS[activeStep]}</Box>;
};
